import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rocket20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M15.625 5.625C15.625 6.31536 15.0654 6.875 14.375 6.875C13.6846 6.875 13.125 6.31536 13.125 5.625C13.125 4.93464 13.6846 4.375 14.375 4.375C15.0654 4.375 15.625 4.93464 15.625 5.625Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2122 3.22703C12.9746 1.46466 15.1625 1.25 17.4999 1.25C18.1903 1.25 18.7499 1.80964 18.7499 2.5C18.7499 4.83742 18.5353 7.02532 16.7729 8.78769L15.2499 10.3107V17.0858C15.2499 18.6449 13.3649 19.4257 12.2625 18.3232L9.17738 15.2381C8.83454 16.9557 7.31842 18.25 5.5 18.25H1.75V14.5C1.75 12.6816 3.04429 11.1655 4.7619 10.8226L1.67672 7.73744C0.574278 6.635 1.35507 4.75 2.91415 4.75H9.68928L11.2122 3.22703ZM6.31066 10.2501L12.2729 4.28769C13.6696 2.891 15.4027 2.75 17.2499 2.75C17.2499 4.59724 17.1089 6.33034 15.7122 7.72703L9.68996 13.6294C8.56352 12.5029 7.43709 11.3765 6.31066 10.2501ZM6.54807 12.6088C6.2563 12.3218 5.89157 12.25 5.5 12.25C4.25736 12.25 3.25 13.2574 3.25 14.5V16.75H5.5C6.74264 16.75 7.75 15.7426 7.75 14.5C7.75 14.1084 7.67816 13.7437 7.39119 13.4519L6.54807 12.6088ZM8.18939 6.25H2.91415C2.69143 6.25 2.57988 6.51929 2.73738 6.67678L5.25 9.1894L8.18939 6.25ZM13.3232 17.2626L10.7507 14.6901L13.7499 11.759V17.0858C13.7499 17.3085 13.4807 17.4201 13.3232 17.2626Z'
      fill='currentColor'
    />
  </Svg>
);

Rocket20.displayName = 'Rocket20';
export default Rocket20;
